import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import {
  Search,
  Authentication,
  Logout,
  Bulletin,
  UserManagement,
  CompanyManagement,
  PasswordReset,
  History,
} from '../containers';

const Routes = (isAuthenticated) => (isAuthenticated ? authenticatedRoutes() : anonymousRoutes());

/**
 * All available routes when authenticated.
 * @returns {*}
 */
const authenticatedRoutes = () => (
  <Switch>
    <Route exact path='/search' component={Search} />
    <Route exact path='/history' component={History} />
    <Route exact path='/bulletin' component={Bulletin} />
    <Route exact path='/users' component={UserManagement} />
    <Route exact path='/companies' component={CompanyManagement} />
    <Route exact path='/logout' component={Logout} />
    <Redirect to='/search' />
  </Switch>
);

/**
 * All available routes when not authenticated.
 * @returns {*}
 */
const anonymousRoutes = () => (
  <Switch>
    <Route exact path='/login' component={Authentication} />
    <Route exact path='/reset/:_id/:_jwt' component={PasswordReset} />
    <Redirect to='/login' />
  </Switch>
);

export default Routes;
